import { doc } from "firebase/firestore";

export const useDocumentContainerHeight = () => {
  try {
    var documentContainerElement =
      document.getElementById("document-container");
    if (!documentContainerElement) {
      return 0;
    }

    var documentBox = documentContainerElement.getBoundingClientRect();

    if (documentBox == undefined || documentBox.height == undefined) return 0;

    return documentBox.height;
  } catch (error) {
    return 0;
  }
};
